import React, { useEffect, useState } from "react";
import { FormGroup, Button, Input, Label } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import CKEditor from "react-ckeditor-component";

const AddStateDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { AuthReducer: { auth } } = useSelector((state) => state);
    const [fields, setFields] = useState([]);
    const [dynamicFields, setDynamicFields] = useState([{ id: '', heading: '', description: '' }]);

    useEffect(() => {
        axios(`/api/admin/v1/add-edit-state/${id}`, {
            headers: { Authorization: `Bearer ${auth?.token}` },
        }).then((res) => {
            setFields(res.data?.stateDetailField || []);
        }).catch((err) => console.error(err));
    }, [auth, id]);

    const handleAddField = () => {
        setDynamicFields([...dynamicFields, { id: '', heading: '', description: '' }]);
    };

    const handleFieldChange = (type, index, key, value) => {
        console.log('Updating field:', type, index, key, value);
        const targetFields = type === 'dynamic' ? dynamicFields : fields;
        const updatedFields = [...targetFields];
        if (index < 0 || index >= updatedFields.length) return;

        updatedFields[index][key] = value;
        type === 'dynamic' ? setDynamicFields(updatedFields) : setFields(updatedFields);
    };
    const handleDeleteField = (type, index) => {
        const targetFields = type === 'dynamic' ? dynamicFields : fields;
        const updatedFields = targetFields.filter((_, i) => i !== index);
        type === 'dynamic' ? setDynamicFields(updatedFields) : setFields(updatedFields);
    };

    const handleSubmit = () => {

        if (dynamicFields.some(field => !field.heading || !field.description)) {
            toast.error("All dynamic fields must have a heading and description.");
            return;
        }
        const form = new FormData();
        form.append('dynamicFields', JSON.stringify([...fields, ...dynamicFields]));
        axios.put(`/api/admin/v1/add-update-dynamic-fields-state/${id}`, form, {
            headers: { Authorization: `Bearer ${auth?.token}` },
        }).then((res) => {
            toast.success(res.data?.message);
            navigate(-1);
        }).catch((err) => {
            toast.error(err.response?.data || "An error occurred.");
        });
    };
    return (
        <div>
            <div className="row my-3">
                <div className="col-md-10">  <h2 className="text-white">State Detail Fields</h2></div>
            </div>
            <div className="bg-white px-3 py-4 rounded-2 my-4">
                <div className="row">
                    <div className="col-md-12">
                        <Button color="primary" className="mt-2" onClick={handleAddField}>
                            Add Field
                        </Button>
                    </div>
                    <div className="col-md-8">
                        {fields.map((field, index) => (
                            <div key={`field-${index}`} className="form-group mt-3 text-dark">
                                <Label className="h5">Heading:</Label>
                                <Button color="danger" className="mt-2" onClick={() => handleDeleteField('fields', index)}>
                                    Delete
                                </Button>
                                <Input
                                    type="text"
                                    value={field.heading}
                                    onChange={(e) => handleFieldChange('fields', index, 'heading', e.target.value)}
                                    placeholder="Enter Heading"
                                />
                                <Label className="h5">Content:</Label>
                                <FormGroup>
                                    <CKEditor
                                        activeClass="p10"
                                        content={field.description}
                                        events={{
                                            change: (evt) => {
                                                const data = evt.editor.getData();
                                                handleFieldChange('fields', index, 'description', data);
                                            }
                                        }}
                                    />
                                </FormGroup>
                            </div>
                        ))}
                        {dynamicFields.map((field, index) => (
                            <div key={`dynamic-${index}`} className="form-group mt-3 text-dark">
                                <div className="d-flex align-items-center justify-content-between mb-2">
                                    <Label className="h5 mb-0">Heading:</Label>
                                    <Button color="danger" className="ms-3" onClick={() => handleDeleteField('dynamic', index)}>
                                        Delete
                                    </Button>
                                </div>
                                <Input type="text" value={field.heading} onChange={(e) => handleFieldChange('dynamic', index, 'heading', e.target.value)} placeholder="Enter Heading" />
                                <Label className="h5">Content:</Label>
                                <FormGroup>
                                    <CKEditor
                                        content={field.description}
                                        events={{
                                            change: (evt) => {
                                                const data = evt.editor.getData();
                                                handleFieldChange('dynamic', index, 'description', data);
                                            }
                                        }}
                                    />
                                </FormGroup>
                            </div>
                        ))}
                    </div>
                    <div className="col-md-12 mt-4">
                        <Button color="success" onClick={handleSubmit}>
                            Submit
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddStateDetails;
